import { useEffect, useState } from "react";
import { adminApi } from "../auth";

const AdminAnalytics = () => {
  const [d, setD] = useState(null);
  useEffect(() => { adminApi.get("/analytics").then((r) => setD(r.data)); }, []);
  if (!d) return <p className="vd-muted">Loading…</p>;

  return (
    <div data-testid="admin-analytics-page">
      <h1 style={{ fontSize: 28 }}>Analytics</h1>
      <p className="vd-muted mb-6">Product engagement, turnover and profitability.</p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-5">
        <SimpleList title="Most viewed products" rows={d.most_viewed} valueKey="views" valueLabel="views" testid="most-viewed-list" />
        <SimpleList title="Most added to cart" rows={d.most_added_to_cart} valueKey="cart_adds" valueLabel="adds" testid="most-cart-list" />
      </div>

      <div className="vd-card p-5 mb-5" data-testid="stock-turnover-table">
        <p className="vd-heading font-semibold mb-3">Stock turnover</p>
        <table className="w-full text-sm">
          <thead><tr className="text-left vd-muted uppercase text-xs tracking-wider">
            <th className="py-2">Product</th><th>Stock</th><th>Sold</th><th>Turnover ratio</th>
          </tr></thead>
          <tbody>
            {d.stock_turnover.map((r) => (
              <tr key={r.id} className="border-t" style={{ borderColor: "var(--border-color)" }} data-testid={`turnover-row-${r.id}`}>
                <td className="py-2 vd-heading">{r.brand} {r.model}</td>
                <td className="vd-muted">{r.stock_qty}</td>
                <td className="vd-muted">{r.units_sold}</td>
                <td className="vd-heading font-semibold" style={{ color: r.turnover_ratio >= 1 ? "#00A35C" : "var(--text-heading)" }}>{r.turnover_ratio}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="vd-card p-5" data-testid="profit-per-product-table">
        <p className="vd-heading font-semibold mb-3">Profit per product</p>
        <table className="w-full text-sm">
          <thead><tr className="text-left vd-muted uppercase text-xs tracking-wider">
            <th className="py-2">Product</th><th>Price</th><th>Wholesale</th><th>Margin %</th><th>Sold</th><th>Total profit</th>
          </tr></thead>
          <tbody>
            {d.profit_per_product.map((r) => (
              <tr key={r.id} className="border-t" style={{ borderColor: "var(--border-color)" }} data-testid={`profit-row-${r.id}`}>
                <td className="py-2 vd-heading">{r.brand} {r.model}</td>
                <td className="vd-muted">£{r.price?.toFixed(2)}</td>
                <td className="vd-muted">{r.wholesale_cost != null ? `£${r.wholesale_cost.toFixed(2)}` : "—"}</td>
                <td className="vd-heading">{r.profit_margin_pct != null ? `${r.profit_margin_pct}%` : "—"}</td>
                <td className="vd-muted">{r.units_sold}</td>
                <td className="vd-heading font-semibold" style={{ color: (r.total_profit || 0) > 0 ? "#00A35C" : "var(--text-heading)" }}>{r.total_profit != null ? `£${r.total_profit.toFixed(2)}` : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const SimpleList = ({ title, rows, valueKey, valueLabel, testid }) => (
  <div className="vd-card p-5" data-testid={testid}>
    <p className="vd-heading font-semibold mb-3">{title}</p>
    {rows.length === 0 ? <p className="vd-muted text-sm">No data yet.</p> : (
      <ul className="divide-y" style={{ borderColor: "var(--border-color)" }}>
        {rows.map((r, idx) => (
          <li key={r.id} className="flex items-center gap-3 py-2" data-testid={`${testid}-row-${idx}`}>
            <span className="vd-muted text-xs w-5">{idx + 1}.</span>
            {r.image && <img src={r.image} alt="" className="w-9 h-9 rounded object-cover" />}
            <div className="flex-1 min-w-0"><p className="vd-heading text-sm font-medium truncate">{r.brand} {r.model}</p></div>
            <span className="vd-heading font-bold text-sm">{r[valueKey]} <span className="vd-muted font-normal text-xs">{valueLabel}</span></span>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default AdminAnalytics;
